<div style="display: flex; justify-content: flex-end;">
  <button type="button" class="btn-close" [mat-dialog-close]=""></button>
</div>
<h1 mat-dialog-title class="m-0">Configuración de Regla para {{ nombreAtributo }}</h1>

<div class="modal-body-scroll">
  <div class="inputform">

    <div class="col-md-5"> 
      <mat-form-field appearance="outline">
        <mat-label>Nombre </mat-label>
        <input matInput [(ngModel)]="dataR.nombre" name="nombre" required>
      </mat-form-field>
    </div>

    <div class="col-md-3">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Tipo</mat-label>
        <mat-select [(ngModel)]="dataR.tipo" name="tipo" (selectionChange)="onTipoCambio($event)" [disabled]="isEdit">
          <mat-option *ngIf="type_att == 4 || type_att == 6" [value]="1">Sumatoria</mat-option>          
          <mat-option [value]="2">Comparativo</mat-option>
          <mat-option [value]="3">Rangos</mat-option>
          <mat-option *ngIf="type_att == 4 || type_att == 6" [value]="4">Conteo de atributos válidos</mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <div *ngIf="(type_att == 4 || type_att == 6)&&(dataR.tipo == 1||dataR.tipo == 4)" class="row">
      <h5 class="fw-bold text-primary">Atributos de la sumatoria</h5>
       <div class="col-sm-4">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Atributo</mat-label>
          <mat-select [(ngModel)]="dataR.data_regla.attributes" name="atributes" multiple>
            <mat-option *ngFor="let atributo of atributos" [value]="atributo.id">{{ atributo.name }}</mat-option>
          </mat-select>
        </mat-form-field>
       </div>
       <div class="col-sm-3">
        <mat-form-field appearance="outline" class="form-field">
         <mat-label>Operador</mat-label>
         <mat-select [(ngModel)]="dataR.data_regla.operador" name="operadorsum">
           <mat-option *ngFor="let operador of operadores" [value]="operador.id">{{operador.nombre}}</mat-option>
         </mat-select>
        </mat-form-field>
       </div>
       <div class="col-sm-3">
         <mat-form-field appearance="outline">
           <mat-label> Valor </mat-label>
           <input matInput type="number" [(ngModel)]="dataR.data_regla.valor_operacion" name="valorsum" required>
           <mat-hint *ngIf="invalidDivisionValue()" style="color: #f44336;">
             El valor debe ser diferente de 0.
           </mat-hint>
         </mat-form-field>
       </div>

      </div>
    </div>

    <div *ngIf="dataR.tipo==2" class="row">
      <h5 class="fw-bold text-primary">Configuración</h5>
      <div class="col-md-3">
        <!--<mat-form-field appearance="outline" class="form-field">
          <mat-label>Atributo</mat-label>
          <mat-select [(ngModel)]="dataR.data_regla.attribute" (selectionChange)="setItemName($event.value, dataR.data_regla)" name="atribute" >
            <mat-option *ngFor="let atributo of atributos" [value]="atributo.id">{{ atributo.name }}</mat-option>
          </mat-select>
        </mat-form-field>-->
          <attr-autocomplete [label]="'Atributo'" [dataSource]="atributos"
          [(selectedId)]="dataR.data_regla.attribute" (selectedIdChange)="setItemName($event, dataR.data_regla)"></attr-autocomplete>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Condición</mat-label>
          <mat-select [(ngModel)]="dataR.data_regla.operador" name="operador">
            <ng-container *ngIf="type_sel != 0" >
              <mat-option *ngIf="[1,3,4,5,6].includes(type_sel)" [value]="3">Igual que</mat-option>
              <mat-option *ngIf="type_sel == 4 || type_sel == 6 " [value]="1">Mayor que</mat-option>
              <mat-option *ngIf="type_sel == 4 || type_sel == 6 " [value]="2">Menor que</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Valor a comparar</mat-label>
          <input matInput [(ngModel)]="dataR.data_regla.valor_comparar" name="valor" placeholder="Ej: Valor a comparar" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field *ngIf="type_att == 1" appearance="outline" class="form-field">
          <mat-label>Valor que el atributo adquirirá</mat-label>
          <mat-select   [(ngModel)]="dataR.data_regla.valor_atributo" name="valor">
            <mat-option  [value]="'SI'">SI</mat-option>
            <mat-option  [value]="'NO'">NO</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="type_att == 3" appearance="outline" class="form-field">
          <mat-label>Valor que el atributo adquirirá</mat-label>
          <mat-select   [(ngModel)]="dataR.data_regla.valor_atributo" name="valor">
            <mat-option *ngFor="let valor of att_options" [value]="valor" >{{ valor }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="[4,5,6].includes(type_att)" appearance="outline" class="form-field">
            <mat-label>Valor que el atributo adquirirá</mat-label>
            <input matInput [(ngModel)]="dataR.data_regla.valor_atributo" name="valor" placeholder="Ej: Valor que el atributo adquirirá" />    
        </mat-form-field>
      </div>
    </div>

    <div *ngIf= "dataR.tipo == 3" class="row">
      <h5 class="fw-bold text-primary">Configuración</h5>
      <div class="col-md-3">
        <!--<mat-form-field appearance="outline" class="form-field">
          <mat-label>Atributo</mat-label>
          <mat-select [(ngModel)]="dataR.data_regla.attribute" name="atribute" >
            <mat-option *ngFor="let atributo of atributos" [value]="atributo.id">{{ atributo.name }}</mat-option>
          </mat-select>
        </mat-form-field>-->
          <attr-autocomplete [label]="'Atributo'" [dataSource]="atributos"
          [(selectedId)]="dataR.data_regla.attribute" (selectedIdChange)="setItemName($event, dataR.data_regla)"></attr-autocomplete>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Valor mínimo</mat-label>
          <input matInput [(ngModel)]="dataR.data_regla.valor_min" name="valor" placeholder="Ej.: Valor mínimo" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Valor máximo</mat-label>
          <input matInput [(ngModel)]="dataR.data_regla.valor_max" name="valor" placeholder="Ej: Valor máximo" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field *ngIf="type_att == 1" appearance="outline" class="form-field">
          <mat-label>Valor que el atributo adquirirá</mat-label>
          <mat-select   [(ngModel)]="dataR.data_regla.valor_atributo" name="valor">
            <mat-option  [value]="'SI'">SI</mat-option>
            <mat-option  [value]="'NO'">NO</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="type_att == 3" appearance="outline" class="form-field">
          <mat-label>Valor que el atributo adquirirá</mat-label>
          <mat-select   [(ngModel)]="dataR.data_regla.valor_atributo" name="valor">
            <mat-option *ngFor="let valor of att_options" [value]="valor" >{{ valor }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="[4,5,6].includes(type_att)" appearance="outline" class="form-field">
            <mat-label>Valor que el atributo adquirirá</mat-label>
            <input matInput [(ngModel)]="dataR.data_regla.valor_atributo" name="valor" placeholder="Ej: Valor que el atributo adquirirá" />
        </mat-form-field>
      </div>
    </div>
  </div>

<div mat-dialog-actions class="button-container">
  <button mat-raised-button *ngIf="!isEdit" class="nest-button" (click)="register()" [disabled]="invalidInput()">Agregar</button>
  <button mat-raised-button *ngIf="isEdit" class="nest-button" (click)="edit()" [disabled]="invalidInput()">Editar</button>
</div>
